import { useState } from 'react';
import { CheckboxList } from '../../components/Checkbox/CheckboxList';
import { IConsultationOutcome } from '../../hooks/promises/getConsultationOutcomes';
import OutcomesSearchBar from './OutcomesSearchBar';
import { StateSetter } from '../../hooks/useCreateAppointmentRequest';
import Spinner from '../../components/Spinner/Spinner';

interface IOutcomesSectionProps {
  outcomeList: IConsultationOutcome[];
  capacityCount: number | undefined;
  shouldShowResultsFallback: boolean;
  setShouldShowResultsFallback: React.Dispatch<React.SetStateAction<boolean>>;
  searchingOutcomes: boolean;
  setSearchingOutcomes: React.Dispatch<React.SetStateAction<boolean>>;
  selectedOutcomes: IConsultationOutcome[];
  setSelectedOutcomes: (items: IConsultationOutcome[]) => void;
  setOtherText: StateSetter<string>;
  otherText: string;
}

export default function OutcomesSection({
  outcomeList,
  capacityCount,
  shouldShowResultsFallback,
  setShouldShowResultsFallback,
  searchingOutcomes,
  setSearchingOutcomes,
  selectedOutcomes,
  setSelectedOutcomes,
  setOtherText,
  otherText,
}: IOutcomesSectionProps) {
  const [filteredOutcomeList, setFilteredOutcomeList] =
    useState<IConsultationOutcome[]>();
  const [userInput, setUserInput] = useState('');

  return (
    <div className="w-[600px] mx-auto mt-10 flex flex-col gap-6">
      <OutcomesSearchBar
        outcomeList={outcomeList}
        setFilteredOutcomeList={setFilteredOutcomeList}
        setShouldShowResultsFallback={setShouldShowResultsFallback}
        setSearchingOutcomes={setSearchingOutcomes}
        userInput={userInput}
        setUserInput={setUserInput}
      />
      {searchingOutcomes ? (
        <div className="flex justify-center mt-16">
          <Spinner />
        </div>
      ) : (
        <CheckboxList
          outcomeList={
            filteredOutcomeList && filteredOutcomeList.length > 0
              ? filteredOutcomeList
              : outcomeList
          }
          selectedOutcomes={selectedOutcomes}
          setSelectedOutcomes={setSelectedOutcomes}
          setOtherText={setOtherText}
          otherText={otherText}
          shouldShowResultsFallback={shouldShowResultsFallback}
          disabled={!capacityCount}
          userSearchString={userInput}
        />
      )}
    </div>
  );
}
